import React, { useContext, useEffect } from 'react'
import { MyContext } from '../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';

const AllPayment = ({ Amount, Url, setIsTrue }) => {

    const { BaseUrl, setPaymentLoading } = useContext(MyContext);


    useEffect(() => {
        handleGetURl();
    }, [Amount]);

    const handleGetURl = async () => {
        const Localdata = secureLocalStorage.getItem("Localdata");
        const JsconData = JSON.parse(Localdata);

        axios.post(BaseUrl + Url, { amount: Amount, uid: JsconData.id, status: 0 })
            .then((res) => {
                console.log(res);
                if (res.data.Result == true) {
                    window.location.href = res.data.PaymentURL;
                } else {
                    enqueueSnackbar(res.data.message , { variant: 'error' });
                }
                setPaymentLoading(false);
                setIsTrue(false);
            })
            .catch((error) => {
                console.error(error);
            })
    }

    return null;
}

export default AllPayment